import request from '@/utils/request'

// 查询部门列表
export function listDept(query) {
  return request({
    url: '/admi/dept/list',
    method: 'get',
    params: query
  })
}

// 查询部门列表（排除节点）
export function listDeptExcludeChild(deptId) {
  return request({
    url: '/admi/dept/list/exclude/' + deptId,
    method: 'get'
  })
}

// 查询部门详细
export function getDept(deptId) {
  return request({
    url: '/admi/dept/' + deptId,
    method: 'get'
  })
}

// 查询部门下拉树结构
export function treeselect() {
  return request({
    url: '/admi/dept/treeselect',
    method: 'get'
  })
}

// 根据角色ID查询部门树结构
export function roleDeptTreeselect(roleId) {
  return request({
    url: '/admi/dept/roleDeptTreeselect/' + roleId,
    method: 'get'
  })
} 

// 新增部门
export function addDept(data) {
  return request({
    url: '/admi/dept',
    method: 'post',
    data: data
  })
}

// 修改部门
export function updateDept(data) {
  return request({
    url: '/admi/dept',
    method: 'put',
    data: data
  })
}

// 删除部门
export function delDept(deptId) {
  return request({
    url: '/admi/dept/' + deptId,
    method: 'delete'
  })
}

// 同步企业微信部门
export function syncQyWxDept() {
  return request({
    url: '/admi/dept/syncQyWxAdd',
    method: 'post'
  })
}

// 查询部门下拉树结构
export function mobileTreeselect() {
  return request({
    url: '/system/dept/mobile/treeselect',
    method: 'get'
  })
}